import React from "react";

const WarningAlert = ({ msg }) => (
    <div className="alert alert-danger p-1 mt-1" >
        <span style={{ fontWeight: 700, fontSize: '1.1em' }}>{msg}</span>
    </div>
);

export default WarningAlert;